module.exports = __webpack_public_path__ + "img/DE00737.2b3c488d.png";